import { Fragment, useLayoutEffect, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
// types
import { NavItemType } from '@/types/bs-types/menu';

// project-imports
import NavItem from './NavItem';
import NavGroup from './NavGroup';
import {
  menuAdminItems,
  menuPaymentUserItems,
  menuResearchUserItems,
  menuResearchManagerItems,
  menuExampleItems,
  menuUserItems
} from '@/components/menu-items';
// import { MenuFromAPI } from '@/components/base-component/menu-items/dashboard';

import useConfig from '@/hooks/useConfig';
import { MenuOrientation, HORIZONTAL_MAX_ITEM } from '@/config';
import { useGetMenu, useGetMenuMaster } from '@/api/menu';
import useAuth from '@/hooks/useAuth';

function isFound(arr: any, str: string) {
  return arr.items.some((element: any) => {
    if (element.id === str) {
      return true;
    }
    return false;
  });
}

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export default function Navigation() {
  const theme = useTheme();
  const { user } = useAuth();

  const downLG = useMediaQuery(theme.breakpoints.down('lg'));

  const { menuOrientation } = useConfig();
  // const { menuLoading } = useGetMenu();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const [selectedID, setSelectedID] = useState<string | undefined>('');
  const [selectedItems, setSelectedItems] = useState<string | undefined>('');
  const [selectedLevel, setSelectedLevel] = useState<number>(0);
  const [menuItems, setMenuItems] = useState<{ items: NavItemType[] }>({ items: [] });

  /*
  let dashboardMenu = MenuFromAPI();

  useLayoutEffect(() => {
    if (user?.activeAccount?.userRole === 'ADMIN') {
      setMenuItems({ items: [...menuAdminItems.items] });
    } else {
      setMenuItems({ items: [...menuUserItems.items] });
    }
  }, []);

  /*
  useLayoutEffect(() => {
    if (menuLoading && !isFound(menuItem, 'group-dashboard-loading')) {
      menuItem.items.splice(0, 0, dashboardMenu);
      setMenuItems({ items: [...menuItem.items] });
    } else if (!menuLoading && dashboardMenu?.id !== undefined && !isFound(menuItem, 'group-dashboard')) {
      menuItem.items.splice(0, 1, dashboardMenu);
      setMenuItems({ items: [...menuItem.items] });
    } else {
      setMenuItems({ items: [...menuItem.items] });
    }

    // eslint-disable-next-line
  }, [menuLoading]);
  */

  useLayoutEffect(() => {
    // admin role
    if (user?.activeAccount?.userRole === 'ADMIN' && user?.activeAccount?.permission === 'NORMAL_ADMIN') {
      setMenuItems({ items: [...menuAdminItems.items] });
    } else if (user?.activeAccount?.userRole === 'ADMIN' && user?.activeAccount?.permission === 'SUPER_ADMIN') {
      setMenuItems({ items: [...menuAdminItems.items, ...menuExampleItems.items] });
    }
    // user role
    else if (user?.activeAccount?.userRole === 'USER' && user?.activeAccount?.permission === 'CUSTOMER') {
      setMenuItems({ items: [...menuUserItems.items] });
      //   setMenuItems({ items: [...menuUserItems.items, ...menuExampleItems.items] });
    }

    // setMenuItems({ items: [...menuExampleItems.items] });
  }, []);

  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;
  const lastItem = isHorizontal ? HORIZONTAL_MAX_ITEM : null;
  let lastItemIndex = menuItems.items.length - 1;
  let remItems: NavItemType[] = [];
  let lastItemId: string;

  if (lastItem && lastItem < menuItems.items.length) {
    lastItemId = menuItems.items[lastItem - 1].id!;
    lastItemIndex = lastItem - 1;
    remItems = menuItems.items.slice(lastItem - 1, menuItems.items.length).map((item) => ({
      title: item.title,
      elements: item.children,
      icon: item.icon,
      ...(item.url && {
        url: item.url
      })
    }));
  }

  const navGroups = menuItems.items.slice(0, lastItemIndex + 1).map((item) => {
    switch (item.type) {
      case 'group':
        if (item.url && item.id !== lastItemId) {
          return (
            <Fragment key={item.id}>
              {menuOrientation !== MenuOrientation.HORIZONTAL && <Divider sx={{ my: 0.5 }} />}
              <NavItem item={item} level={1} isParents />
            </Fragment>
          );
        }
        return (
          <NavGroup
            key={item.id}
            selectedID={selectedID}
            setSelectedID={setSelectedID}
            setSelectedItems={setSelectedItems}
            setSelectedLevel={setSelectedLevel}
            selectedLevel={selectedLevel}
            selectedItems={selectedItems}
            lastItem={lastItem!}
            remItems={remItems}
            lastItemId={lastItemId}
            item={item}
          />
        );
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            {/* Fix - Navigation Group */}
          </Typography>
        );
    }
  });
  return (
    <Box
      sx={{
        pt: drawerOpen ? (isHorizontal ? 0 : 2) : 0,
        '& > ul:first-of-type': { mt: 0 },
        display: isHorizontal ? { xs: 'block', lg: 'flex' } : 'block'
      }}
    >
      {navGroups}
    </Box>
  );
}
